import { useAuth } from "../auth/useAuth";

/**
 * Hook for checking granular RBAC permissions.
 *
 * Reads the `permissions` array from the user object (populated by the API)
 * and exposes simple predicate functions.
 *
 * Usage:
 *   const { can, canAny, canAll } = usePermissions();
 *   if (can("directory.clients.create")) { ... }
 */
export function usePermissions() {
  const { user } = useAuth();

  const permSet = new Set(user?.permissions || []);

  const can = (permission) => {
    if (user?.is_superuser) return true;
    return permSet.has(permission);
  };

  const canAny = (...permissions) => {
    if (user?.is_superuser) return true;
    return permissions.some((p) => permSet.has(p));
  };

  const canAll = (...permissions) => {
    if (user?.is_superuser) return true;
    return permissions.every((p) => permSet.has(p));
  };

  return { can, canAny, canAll, permissions: user?.permissions || [] };
}
